import { DateTime } from "luxon";
import { DrivingDay } from "../../../../../../API/drivingDay";

export function isSingleDayDrive(day: DrivingDay): boolean {
  const start = DateTime.fromISO(day.day_start_time);
  const end = DateTime.fromISO(day.day_end_time);
  return end.diff(start, "hours").hours <= 25;
}
